'use client'

import type { Image as SpaceImage } from '@cocoonspace/sdk-js/types/image'
import { useEffect, useState } from 'react'
import {
	Carousel,
	type CarouselApi,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
} from '@cocoonspace/ui/components/carousel'
import { TwicImg } from '@twicpics/components/react'

export const VenueImageCarousel = ({
	photos,
	defaultIndex,
}: {
	photos: SpaceImage[]
	defaultIndex?: number
}) => {
	const [api, setApi] = useState<CarouselApi>()
	const [index, setIndex] = useState(defaultIndex || 0)

	useEffect(() => {
		if (!api) return

		api.on('select', () => {
			setIndex(api.selectedScrollSnap())
		})
	}, [api])

	return (
		<div className='relative flex w-full flex-col items-center gap-4 overflow-hidden rounded-lg'>
			<Carousel
				className='w-full max-w-screen-lg'
				opts={{
					loop: true,
					slidesToScroll: 1,
					startIndex: defaultIndex ?? 0,
				}}
				setApi={setApi}
			>
				<CarouselContent>
					{photos.map((image, index) => (
						<CarouselItem key={index}>
							<TwicImg
								alt={image.title}
								preTransform='resize=1024x-/quality=80/focus=-x360'
								ratio='3/2'
								src={image.path}
							/>
						</CarouselItem>
					))}
				</CarouselContent>

				<CarouselPrevious />
				<CarouselNext />
			</Carousel>

			<p className='hidden text-center lg:block'>
				{index + 1}/{photos.length}
			</p>
		</div>
	)
}
